import HomeworkStatus from './status';
import is from 'is_js';

const PUBLISHED = HomeworkStatus.PUBLISHED.toLowerCase();

export function getHomeworkBySessionId(state, sessionId) {
  return state.get('rootReducer').get('homework').get(`${sessionId}`);
}

export function getHomeworkContentBySessionid(state, sessionId) {
  return state.get('rootReducer').get('homeworkContent').get(sessionId);
}

export function getHomeworkTemplateBySessionId(state, sessionId) {
  return state.get('rootReducer').get('homeworkTemplate').get(sessionId);
}

export function getOnlineHomeworkBySessionId(state, sessionId) {
  return state.get('rootReducer').get('onlineHomeworkContent').get(sessionId);
}

export function hasWronglyResult(state, sessionId) {
  const homeworkContent = getHomeworkContentBySessionid(state, sessionId);
  const homeworkTemplate = getHomeworkTemplateBySessionId(state, sessionId);
  const onlineHomework = getOnlineHomeworkBySessionId(state, sessionId);
  if (is.existy(homeworkContent) &&
    is.existy(homeworkTemplate) &&
    is.existy(onlineHomework) &&
    homeworkContent.size > 0) {
    return homeworkContent.size !== homeworkContent.filter((h) =>
      onlineHomework.some((o) => o.unitId === h.unitId &&
        o.lessonNumber === h.lessonNumber) ||
      homeworkTemplate.some((t) => t.unitId === h.unitId &&
        t.lessonNumber === h.lessonNumber)).size;
  }

  return undefined;
}

export function isPublished(state, sessionId) {
  const homework = getHomeworkBySessionId(state, sessionId);
  return homework.homeworkResultStatus.toLowerCase() === PUBLISHED;
}

export function isExisty(state, sessionId) {
  const summary = state.get('rootReducer').get('homework').get(`${sessionId}`);
  return summary && summary.size > 0;
}



// WEBPACK FOOTER //
// ./data/Homework/accessors.js